<template>
  <section>
    <header id="header" :class="navbarColor">
      <!--logo start-->
      <div :class="`brand ${navbarColor}`">
        <router-link
          :to="{ name: 'login' }"
          class="logo"
        >
          {{ appName }}
        </router-link>
      </div>
    </header>
    <div class="row">
      <div class="col-lg-6 m-auto">
        <card :title="$t('reset_password')">
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="send"
          >
            <v-col cols="12">
              <v-text-field
                v-model="form.email"
                :rules="[rules.required, rules.emailFormat]"
                label="Correo Electrónico"
                placeholder="ejemplo@dominio.com"
                required
              />
            </v-col>
            <v-col cols="12">
              <v-btn
                :disabled="!valid || form.busy"
                class="mr-4"
                :loading="form.busy"
                color="success"
                block
                @click="validate"
              >
                {{ $t('send_password_reset_link') }}
              </v-btn>
            </v-col>
          </v-form>
        </card>
      </div>
    </div>
  </section>
</template>

<script>
import Form from 'vform';
import { mapGetters } from 'vuex';

export default {
  middleware: 'guest',
  layout: 'password',

  metaInfo() {
    return { title: this.$t('reset_password') };
  },

  data: () => ({
    appName: window.config.appName,
    form: new Form({
      email: '',
    }),
    rules: {
      required: (v) => !!v || 'El campo es requerido.',
      emailFormat: (v) => /.+@.+\..+/.test(v) || 'El campo debe tener un correo electrónico válido.',
    },
    valid: false,
    apiURL: '/api/password/email',
    method: 'POST',
  }),
  mounted() {
    if (this.navbarColor === undefined) {
      this.setTheme('blue');
    }
  },
  computed: {
    ...mapGetters({
      navbarColor: 'theme/navbarColor',
    }),
  },

  methods: {
    async send() {
      this.form.busy = true;

      window.axios({
        method: this.method,
        url: this.apiURL,
        data: this.form,
      }).then((result) => {
        this.$store.dispatch('notifications/show', {
          message: result.data.status,
          type: 'success',
        });
        this.$router.push({ name: 'login', params: { action: 'logout', message: result.data.status } });
        this.form.busy = false;
      }).catch(() => {
        this.form.busy = false;
      });
    },

    validate() {
      if (this.$refs.form.validate()) {
        this.send();
      }
    },
  },
};
</script>
